module.exports = __webpack_public_path__ + "assets/RamsImg.png";


//////////////////
// WEBPACK FOOTER
// ./libs/images/RamsImg.png
// module id = 345
// module chunks = 0